import ApplicationsLoading from '@/features/applications/loading'
import ApplicationsPage from '@/features/applications/page'
import { validateTenantApplicationsSearch } from '@/features/applications/search-defaults'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/companies/$companySlug/applications/')({
  component: ApplicationsPage,
  pendingComponent: ApplicationsLoading,
  validateSearch: validateTenantApplicationsSearch,
})
